import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import {
  ApolloProvider,
  createHttpLink,
  ApolloClient,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import reportWebVitals from './reportWebVitals';
import Routes from './routes';
import errorLink from './apollo/errorHandling';
import cache from './apollo/cache';
import { graphqlUri } from './config/env';
import { readAuthToken } from './utils/authToken';
import ErrorBoundary from './components/error-boundary/ErrorBoundary';

const httpLink = createHttpLink({ uri: graphqlUri });

const authLink = setContext(async (_, { headers }) => {
  const token = readAuthToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const client = new ApolloClient({
  link: from([authLink, errorLink, httpLink]),
  cache,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-first',
      errorPolicy: 'none',
      notifyOnNetworkStatusChange: true,
    },
  },
});

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container "#root" was not found in the document.');
}

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ApolloProvider client={client}>
        <Routes />
      </ApolloProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
